@let r = rendering();
<p>{{ r.subtitle }}</p>

<form
  [formGroup]="usageQuestionnaireForm"
  (ngSubmit)="onSubmit()"
  [wlTrackStep]="{
    rendering: { componentName: 'verbruik inschatten' },
    step: 0.1,
    stepName: 'verbruik inschatten',
  }"
>
  <div class="questionnaire-form-control">
    <crnt-form-control>
      <crnt-select>
        <select
          id="residents"
          formControlName="residents"
          wlAutomationId="usageQuestionnaire.residents"
          [wlTrackValueChange]="{
            step: 0.1,
            rendering: { componentName: 'verbruik inschatten' },
            label: 'aantal personen',
            inputLabel:
              usageQuestionnaireForm.controls.residents.value?.toString() || '',
            sendValue: true,
            trackFocus: true,
            stepName: 'verbruik inschatten',
          }"
        >
          <option [ngValue]="null" selected>
            {{ r.residentsDefaultOption }}
          </option>
          @for (option of r.residentsOptions; track option.label) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </crnt-select>
      <crnt-form-control-label slot="label">
        <label for="residents">{{ r.residentsLabel }}</label>
      </crnt-form-control-label>
      @if (fieldIsInvalid('residents')) {
        <crnt-form-control-validation-message slot="validation">{{
          r.residentsRequiredError
        }}</crnt-form-control-validation-message>
      }
    </crnt-form-control>
  </div>

  <div class="questionnaire-form-control">
    <crnt-form-control>
      <crnt-select>
        <select
          id="houseType"
          formControlName="houseType"
          wlAutomationId="usageQuestionnaire.housingType"
          [wlTrackValueChange]="{
            step: 0.1,
            rendering: { componentName: 'verbruik inschatten' },
            label: 'type huis',
            inputLabel: usageQuestionnaireForm.controls.houseType.value || '',
            sendValue: true,
            trackFocus: true,
            stepName: 'verbruik inschatten',
          }"
        >
          <option [ngValue]="null" selected>
            {{ r.houseTypeDefaultOption }}
          </option>
          @for (option of r.houseTypeOptions; track option.label) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </crnt-select>
      <crnt-form-control-label slot="label">
        <label for="houseType">{{ r.houseTypeLabel }}</label>
      </crnt-form-control-label>
      @if (fieldIsInvalid('houseType')) {
        <crnt-form-control-validation-message slot="validation">{{
          r.houseTypeRequiredError
        }}</crnt-form-control-validation-message>
      }
    </crnt-form-control>
  </div>

  <crnt-button type="submit" wlAutomationId="usageQuestionnaire.submit">{{
    r.primaryButtonLabel
  }}</crnt-button>
</form>
